<template>
  <div>
    <Loader v-if="loader" />
    <v-card class="mx-auto mt-n3" v-if="!loader">
      <!-- Carousel Section -->
      <v-img :src="`${url}${data.banners[0].web}`" class="my-3" contain />
      <!-- <v-carousel
        :show-arrows="false"
        height="auto"
        cycle   
        hide-delimiters
        class="topBanner pb-10"
      >
        <v-carousel-item
          v-for="(item, i) in data.banners"
          :key="i"
          :src="`${url}${item.web}`"
          class="my-3"
        >
          <div dark class="overlay">
            <v-row class="fill-height" align="center" justify="center">
              <v-col>
                <v-container
                  :class="{ responisiveSlider: $vuetify.breakpoint.smAndDown }"
                >
                  <div
                    class="slider-title"
                    :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-15'"
                  >
                    {{ item.title }}
                  </div>
                </v-container>
              </v-col>
            </v-row>
          </div>
        </v-carousel-item>
      </v-carousel> -->
      <!-- Carousel Section -->

      <!-- Header Section -->
      <v-card-title
        class="justify-center text-uppercase page-title"
        :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
      >
        {{ data.facility.title }}
      </v-card-title>
      <v-card-subtitle
        class="text-center page-sub-title"
        :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
      >
        <h1 :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'mt-0'">
          {{ data.title }}
        </h1>
      </v-card-subtitle>
      <!-- Header Section -->

      <!-- Content Section -->
      <v-container
        class="bg-surface-variant"
        :class="$vuetify.breakpoint.smAndDown ? 'mt-0' : 'mt-5'"
      >
        <div v-for="(material, index) of materials" :key="index">
          <v-row class="bestSellerBlk mt-15 py-3">
            <v-col sm="6" md="6">
              <v-card class="mx-auto" flat>
                <div class="d-flex flex-no-wrap justify-space-between">
                  <v-avatar
                    size="45"
                    rounded="0"
                    style="float: left"
                    :class="$vuetify.breakpoint.smAndDown ? 'mt-1' : 'mt-2'"
                  >
                    <v-img src="../../assets/images/bestsellerIcon.svg"></v-img>
                  </v-avatar>
                  <v-card-text>
                    <div
                      class="text-h5 text--primary"
                      :class="{ sliderTxtSm: $vuetify.breakpoint.smAndDown }"
                    >
                      <span>{{ material.name }}</span>
                    </div>
                  </v-card-text>
                </div>
              </v-card>
            </v-col>
            <v-col sm="6" md="6">
              <v-btn
                dark
                large
                class="gradient-button anchorTag"
                style="float: right"
                @click="onViewAll(material._id)"
              >
                <a> View All</a>
              </v-btn>
            </v-col>
          </v-row>

          <v-row
            dense
            v-scrollanimation
            align="center"
            :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
          >
            <v-col
              v-for="(product, i) in material.products"
              :key="i"
              class="px-3 product-tile"
              cols="12"
              md="4"
              sm="6"
            >
              <v-card
                flat
                class="mx-auto ma-2"
                height="auto"
                width="100%"
                @click="onSelectProduct(product)"
              >
                <v-hover>
                  <v-card
                    flat
                    :class="`${hover ? 'imgover' : 'imgleave'}`"
                    slot-scope="{ hover }"
                  >
                    <v-img
                      :src="`${url}${product.images[0]}`"
                      class="mt-3 mb-3 rounded-xl"
                    ></v-img>
                  </v-card>
                </v-hover>

                <v-card-title align="center" justify="center">{{
                  product.sku.name
                }}</v-card-title>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <!-- Content Section -->

      <!-- Dialog Section -->
      <v-dialog
        transition="dialog-bottom-transition"
        scrollable
        max-width="930"
        style="box-shadow: none !important"
        v-model="dialog"
        :retain-focus="false"
      >
        <template v-slot:default="dialog">
          <v-card
            flat
            class="rounded-xl popuplgScreen"
            :class="{ popupsmallScreen: $vuetify.breakpoint.smAndDown }"
          >
            <v-row>
              <v-col sm="12" md="12">
                <v-btn icon dark @click="closeDialog()" class="closeBtn">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col></v-row
            >
            <v-row
              class="pb-15 rounded-xl"
              :class="$vuetify.breakpoint.smAndDown ? 'pr-0' : 'pr-8'"
            >
              <v-col sm="12" md="6">
                <v-sheet>
                  <v-hover>
                    <v-card
                      :class="`${hover ? 'imgover' : 'imgleave'}`"
                      slot-scope="{ hover }"
                      flat
                    >
                      <v-img
                        :src="`${url}${selectedProduct.images[0]}`"
                        class="popupImg"
                        :width="$vuetify.breakpoint.smAndDown ? '100%' : '100%'"
                        :class="{
                          popupImgsmallScreen: $vuetify.breakpoint.smAndDown,
                        }"
                        contain
                      ></v-img>
                    </v-card> </v-hover
                ></v-sheet>
              </v-col>

              <v-col
                sm="12"
                md="6"
                class="modelTextDesktop"
                :class="{
                  modalTextmobile: $vuetify.breakpoint.smAndDown,
                }"
              >
                <v-row>
                  <v-col
                    cols="12"
                    :class="{
                      modalText: $vuetify.breakpoint.smAndDown,
                    }"
                  >
                    <div class="mt-2">
                      <p class="justify-center text-uppercase page-title">
                        {{ selectedProduct.category.name }}
                      </p>
                    </div>

                    <h1>{{ selectedProduct.sku.name }}</h1>

                    <p class="mt-2">
                      {{ selectedProduct.sku.description }}
                    </p>

                    <v-card-actions class="mt-5">
                      <v-btn
                        :href="`https://godutyfree.in`"
                        block
                        rounded
                        dark
                        class="gradient-button"
                        target="_blank"
                      >
                        Website
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                </v-row></v-col
              >
            </v-row>
          </v-card>
        </template>
      </v-dialog>
      <!-- Dialog Section -->
    </v-card>
  </div>
</template>
<script>
import config from "../../config";
import api from "../../api";
import Loader from "../../components/Loader.vue";
export default {
  name: "Template-6",
  props: ["data"],
  components: {
    Loader,
  },
  data() {
    return {
      url: config.airport.url,
      materials: [],
      products: [],
      dialog: false,
      loader: false,
    };
  },
  methods: {
    async onLoadProducts() {
      try {
        for (const material of this.materials) {
          let payload = {
            page: 1,
            limit: 3,
            filters: {
              materialGroup: material._id,
            },
          };
          const { data } = await api.airport.post(`/user/product`, payload);
          if (data.data) {
            material.products = data.data.docs;
          }
        }
      } catch (error) {}
    },
    async onLoadMaterialGroups() {
      try {
        let payload = {
          page: 1,
          limit: 100,
        };
        const { data } = await api.airport.post(
          `/user/material-group`,
          payload
        );
        if (data.data) {
          this.materials = data.data.docs;
        }
      } catch (error) {}
    },
    onSelectProduct(product) {
      this.selectedProduct = product;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    onViewAll(id) {
      this.$router.push(`/product/${id}/${this.data._id}`);
    },
  },
  async mounted() {
    this.loader = true;
    await this.onLoadMaterialGroups();
    await this.onLoadProducts();
    this.loader = false;
  },
};
</script>
<style scoped>
.gradi-Box {
  position: relative;
  display: inline-block;
  border-radius: 30px !important;
}

.gradi-Box::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: inline-block;
  background: -webkit-gradient(
    90deg,
    rgba(17, 24, 39, 0.1) 0.08%,
    rgba(17, 24, 39, 0.3) 41.89%,
    rgba(17, 24, 39, 0.8) 100%
  );
  /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(
    90deg,
    rgba(17, 24, 39, 0.1) 0.08%,
    rgba(17, 24, 39, 0.3) 41.89%,
    rgba(17, 24, 39, 0.8) 100%
  );
  /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(
    90deg,
    rgba(17, 24, 39, 0.1) 0.08%,
    rgba(17, 24, 39, 0.3) 41.89%,
    rgba(17, 24, 39, 0.8) 100%
  );
  /* Opera 11.10+ */
  background: -ms-linear-gradient(
    90deg,
    rgba(17, 24, 39, 0.1) 0.08%,
    rgba(17, 24, 39, 0.3) 41.89%,
    rgba(17, 24, 39, 0.8) 100%
  );
  /* IE10+ */
  background: linear-gradient(
    90deg,
    rgba(17, 24, 39, 0.1) 0.08%,
    rgba(17, 24, 39, 0.3) 41.89%,
    rgba(17, 24, 39, 0.8) 100%
  );
  /* W3C */
}

.v-sheet.v-footer:not {
  box-shadow: none;
}

.v-sheet.v-card {
  box-shadow: none !important;
}

.atdairport .imageBox {
  position: relative;
}

.atdairport .imageBox-txt {
  position: absolute;
  bottom: 45px;
  left: 25px;
}

.imageBox-txt p {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 44px;
  letter-spacing: -0.02em;
  color: #ffffff;
  float: left;
}

.imageBox-txt .gradient-button {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px !important;
  text-align: center;
  color: #ffffff !important;
  /* float: right; */
  margin-right: 0;
}

.imageBox-txt-two p {
  position: absolute;
  top: 20px;
  left: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #374151;
}

.imgTextBoxHalf p {
  float: left;
  width: 72%;
}

.imgTextBoxHalf v-btn {
  float: right;
}

.atdairport .v-card__actions {
  display: block;
}

.atdairport .imageBox-txt span {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}

.bestseller h2,
.newarrival h2 {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.02em;
  color: #374151;
}

.bestseller p,
.newarrival p {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #6b7280;
}

.bestseller,
.newarrival,
.featuresBlk,
.category {
  margin-top: 80px;
}

.featuresBlk .text-h5 {
  font-style: normal;
  font-weight: 700;
  font-size: 20px !important;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: #374151;
}
.featuresBlk p {
  font-style: normal;
  font-weight: 500;
  font-size: 16px !important;
  line-height: 24px;
  color: #6b7280;
}

.viewBtn {
  margin-left: 110px !important;
  margin-top: 0 !important;
}

.charmSmall .imageBox-txt .gradient-button {
  font-weight: 500;
  font-size: 12px;
}

.charmSmall .imageBox-txt-two p {
  font-size: 14px;
}

.charmSmall .imageBox-txt p {
  font-size: 22px;
}
.charmSmall .imgTextBoxHalf p {
  width: 100%;
}
.charmSmall.atdairport .imageBox-txt {
  bottom: 28px;
}

.charmSmall .featuresBlk .text-h5 {
  font-size: 17px !important;
}
.charmSmall .featuresBlk p {
  font-size: 14px;
}

.charmSmall.category,
.charmSmall.featuresBlk {
  margin-top: 40px;
}

.theme--dark.v-btn.v-btn--icon {
  color: #000 !important;
}

.overlay {
  width: 100%;
  height: 100%;
  /*background: linear-gradient(180deg, rgba(17, 24, 39, 0.2) 0.08%, rgba(17, 24, 39, 0.4) 41.89%, rgba(17, 24, 39, 0.8) 100%);*/
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.slider-title {
  font-size: 32px;
  font-weight: 700;
  width: 50%;
  line-height: 50px;
  color: #fff;
  letter-spacing: 1px;
}

.responisiveSlider .slider-title {
  font-size: 12px;
  width: 80%;
  line-height: 20px;
}
.sliderTxtSm span {
  font-size: 20px;
}

/* New Css */

.v-progress-circular {
  margin: 1rem;
}
.v-sheet.v-footer:not {
  box-shadow: none;
}

.v-sheet.v-card {
  box-shadow: none !important;
}

.imgTextBoxHalf p {
  float: left;
  width: 72%;
}

.imgTextBoxHalf v-btn {
  float: right;
}

.bestseller,
.newarrival,
.featuresBlk,
.category {
  margin-top: 80px;
}

.featuresBlk .text-h5 {
  font-style: normal;
  font-weight: 700;
  font-size: 20px !important;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: #374151;
}
.featuresBlk p {
  font-style: normal;
  font-weight: 500;
  font-size: 16px !important;
  line-height: 24px;
  color: #6b7280;
}

.viewBtn {
  margin-left: 110px !important;
  margin-top: 0 !important;
}

.charmSmall .imgTextBoxHalf p {
  width: 100%;
}

.charmSmall .featuresBlk .text-h5 {
  font-size: 17px !important;
}
.charmSmall .featuresBlk p {
  font-size: 14px;
}

.charmSmall.category,
.charmSmall.featuresBlk {
  margin-top: 40px;
}

.theme--dark.v-btn.v-btn--icon {
  color: #000 !important;
}

.overlay {
  width: 100%;
  height: 100%;
  /*background: linear-gradient(180deg, rgba(17, 24, 39, 0.2) 0.08%, rgba(17, 24, 39, 0.4) 41.89%, rgba(17, 24, 39, 0.8) 100%);*/
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.slider-title {
  font-size: 32px;
  font-weight: 700;
  width: 50%;
  line-height: 50px;
  color: #fff;
  letter-spacing: 1px;
}

.responisiveSlider .slider-title {
  font-size: 12px;
  width: 80%;
  line-height: 20px;
}
.sliderTxtSm span {
  font-size: 20px;
}

.product-tile {
  box-shadow: rgba(50, 50, 40, 0.1) 0px 30px 70px -15px;
  text-align: center;
  height: 330px;
}

.v-card--link:before {
  background: #fff;
}

.product-tile .v-card__title {
  font-size: 16px;
  display: inline;
}
.dtlrestu {
  margin-top: 5px;
  margin-left: 4px;
}

.modelTextDesktop h1 {
  line-height: 38px;
  margin-bottom: 10px;
  font-size: 30px;
}
.modalTextmobile h1 {
  font-size: 20px;
  line-height: 28px;
}

.popupImg {
  border-radius: 0 30px 30px 0 !important;
  margin-top: 20px;
  margin-right: 20px;
}

.popupImgsmallScreen {
  border-radius: 15px !important;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  margin-top: 10px;
}

.popuplgScreen {
  padding: 50px 0 10px 0 !important;
}

.popupsmallScreen {
  padding: 15px !important;
}
.popupsmallScreen .v-card__actions {
  display: inline-flex;
}

.modelTextDesktop {
  padding: 0 50px 0 50px;
}
.modelTextDesktop p {
  margin: 5px;
}
.modalTextmobile {
  padding: 0 20px;
}

.modelText {
  padding: 0 0 0 0 !important;
}
.closeBtn {
  float: right;
  margin-right: 40px;
}
</style>
